import React from 'react';
import { HaierCostingStatusType, HaierCostingStatusText } from 'shared/constants/status';
import { StyledTag } from './Styles';

type TagStatusProps = {
  status: 1 | 2 | 3 | 4 | 5 | 6;
};

const convertToStatusType = (status: TagStatusProps['status']): string => {
  switch (status) {
    case 1:
      return HaierCostingStatusType.WAITING_CONFIRM;
    case 2:
      return HaierCostingStatusType.TO_VERIFY;
    case 3:
      return HaierCostingStatusType.APPROVED;
    case 4:
      return HaierCostingStatusType.REJECT;
    case 5:
      return HaierCostingStatusType.EDIT;
    case 6:
      return HaierCostingStatusType.CANCEL;
    default:
      return status;
  }
};

const getTextStatus = (statusName: string) => {
  return HaierCostingStatusText[statusName];
};

const TagStatus: React.FC<TagStatusProps> = (props) => {
  const { status } = props;
  const statusType = convertToStatusType(status);
  const text = getTextStatus(statusType);
  return <StyledTag type={statusType}>{text}</StyledTag>;
};

export default TagStatus;
